function StandalonePage() {

    // if element with ID 'current-year' exists, set the current year in
    // the simple footer
    if (document.getElementById("current-year")) {
      const currentYear = new Date().getFullYear();
      document.getElementById("current-year").textContent = currentYear;
    }

    function convertHeadingToId(inputString) {
      const lowercaseString = inputString.toLowerCase();
      const stringWithHyphens = lowercaseString.replace(/ /g, '-');
      const finalString = stringWithHyphens.replace(/[^a-z0-9-]/g, '');
      return finalString;
    }

    // each id should be derived from the header string with spaces
    // replaced with hyphens and use only lowercase letters - no
    // numbers or symbols
    function createTableOfContents() {
      const mainHeadings = document.querySelectorAll('main *:is(h2, h3, h4, h5, h6)');
      const tocTarget = document.getElementsByClassName("quick-nav")[0];
      let currentHeadingLevel = 0;
      let lastItem = tocTarget;

      mainHeadings.forEach((heading) => {
        const headingId = convertHeadingToId(heading.innerHTML);
        const level = parseInt(heading.tagName.slice(1), 10);

        if (level > currentHeadingLevel) {
          const newList = document.createElement('ul');
          const newItem = document.createElement('li');
          const newLink = document.createElement('a');

          newList.appendChild(newItem);
          newItem.appendChild(newLink);
          newLink.innerHTML = heading.innerHTML;
          newLink.setAttribute("href", `#${headingId}`);

          lastItem.appendChild(newList);
          lastItem = newItem;

          currentHeadingLevel = level;

        } else if (level === currentHeadingLevel) {
          const newItem = document.createElement('li');
          const newLink = document.createElement('a');

          newItem.appendChild(newLink);
          newLink.innerHTML = heading.innerHTML;
          newLink.setAttribute("href", `#${headingId}`);

          lastItem.parentElement.appendChild(newItem);
          lastItem = newItem;

        } else {
          let parentItem = lastItem.parentElement;

          while (level < currentHeadingLevel) {
            parentItem = parentItem.parentElement.parentElement;
            currentHeadingLevel -= 1;
          }
          const newItem = document.createElement('li');
          const newLink = document.createElement('a');

          newItem.appendChild(newLink);
          newLink.setAttribute("href", `#${headingId}`);
          newLink.innerHTML = heading.innerHTML;

          parentItem.appendChild(newItem);
          lastItem = newItem;
          currentHeadingLevel = level;
        }
        heading.setAttribute("id", headingId);
      });
    }
    createTableOfContents();
  }
  export default StandalonePage();
